(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../loading/index", "../_util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../loading/index"), require("../_util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.index, global._util);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _index2, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _index2 = _interopRequireDefault(_index2);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show"
        }],
        staticClass: "nx-brand-loading"
      }, [_c('div', {
        staticClass: "nx-brand-loading-content",
        style: {
          paddingTop: _vm.statusBarHeight / 100 + "rem"
        }
      }, [_c('nx-loading', {
        attrs: {
          "show": true,
          "theme": "light",
          "is-vivo-pay": _vm.isVivoPay,
          "location": _vm.location
        }
      }, [_vm.desc ? void 0 : _vm._e()], 2)], 1)]);
    },
    name: 'nx-brand-loading',
    components: (0, _defineProperty2.default)({}, _index2.default.name, _index2.default),
    props: {
      show: Boolean,
      desc: {
        type: String,
        default: '安全 可靠 可信赖'
      },
      isVivoPay: {
        type: Boolean,
        default: false
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          if (_util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1) {
            return true;
          } else {
            return false;
          }
        }
      },
      location: {
        type: String,
        default: 'center'
      }
    },
    data: function data() {
      return {
        fullscreen: true,
        hasMask: true,
        barStyles: {}
      };
    },
    computed: {
      statusBarHeight: function statusBarHeight() {
        return !this.isWebviewFull && _util.isCombineWallet ? 240 : 0;
      }
    }
  };
  _exports.default = _default2;
});